import APIService from "services/ApiService";
import { BatchJob, BatchJobView } from "reducers/types";

// Typed access to a job type's endpoints through the existing APIService (same host, auth and headers).
// basePath is the job type's address, e.g. "/admin/resources/update/tefas/history":
//   POST {base}                    start (body = the job's params)
//   GET  {base}/current?items=     the job to show + queued jobs (chosen by the server)
//   POST {base}/{jobId}/cancel|approve|retry
// No toasts here: the polling hook and the cards decide what to show.

const api = new APIService();

const unwrapJob = (res: any): BatchJob => {
  if (!res || !res.result || !res.result.jobId) {
    throw new Error("BAD_RESPONSE");
  }
  return res.result as BatchJob;
};

const unwrapView = (res: any): BatchJobView => {
  if (!res || !res.result || !Array.isArray(res.result.queued)) {
    throw new Error("BAD_RESPONSE");
  }
  return res.result as BatchJobView;
};

const JobApi = {
  start: (basePath: string, params: object): Promise<BatchJob> => api.post(basePath, params).then(unwrapJob),

  current: (basePath: string, items = true): Promise<BatchJobView> =>
    api.get(`${basePath}/current`, { items: items ? undefined : "false" }).then(unwrapView),

  cancel: (basePath: string, jobId: string): Promise<BatchJob> =>
    api.post(`${basePath}/${jobId}/cancel`).then(unwrapJob),

  approve: (basePath: string, jobId: string): Promise<BatchJob> =>
    api.post(`${basePath}/${jobId}/approve`).then(unwrapJob),

  retry: (basePath: string, jobId: string, items?: string[]): Promise<BatchJob> =>
    api.post(`${basePath}/${jobId}/retry`, items && items.length > 0 ? { items } : {}).then(unwrapJob),
};

export default JobApi;
